import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store' // 假设你使用 Vuex
Vue.use(VueRouter)

const Layout = () => import('@/layout/index.vue')

const routes = [
  {
    path: '/',
    // name: 'home',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'index',
        component: () => import('@/views/home.vue')
      }
    ]
  },
  {
    path: '/immigrationPage',
    name: 'immigrationPage',
    component: Layout,
    redirect: '/immigration.html',
    children: [
      {
        path: '/immigration.html',
        name: 'immigration',
        component: () => import('@/views/immigration/index.vue')
      },
      {
        path: '/immigration/detail/:id.html',
        name: 'immigrationDetail',
        component: () => import('@/views/immigration/detail.vue')
      }
    ]
  },
  {
    path: '/case',
    name: 'case',
    component: Layout,
    children: [
      {
        path: '/case.html',
        name: 'Case',
        component: () => import('@/views/case/index.vue')
      },
      {
        path: '/case/detail/:id.html',
        name: 'CaseDetail',
        component: () => import('@/views/case/detail.vue')
      }
    ]
  },
  {
    path: '/newsCenterPage',
    name: 'newsCenterName',
    component: Layout,
    children: [
      {
        path: '/newsCenter.html',
        name: 'newsCenter',
        component: () => import('@/views/news/index.vue')
      },
      {
        path: '/newsCenter/detail/:id.html',
        name: 'newsDetail',
        component: () => import('@/views/news/detail.vue')
      }
    ]
  },
  {
    path: '/contactPage',
    name: 'contactName',
    component: Layout,
    children: [
      {
        path: '/contact.html',
        name: 'contact',
        component: () => import('@/views/contact/index.vue')
      },
      {
        path: '/contact/assess.html',
        name: 'assessPage',
        component: () => import('@/views/contact/assess.vue')
      }
    ]
  }
]

// 解决重复点击菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const createRouter = () =>
  new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior: () => ({ y: 0 })
  })
const router = createRouter()

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查当前路由是否包含 source 参数
  const sourceParam = to.query.source

  if (sourceParam) {
    // 将 source 参数保存到全局状态
    store.commit('SET_SOURCE_PARAM', sourceParam)
  }

  // 获取全局存储的 source 参数
  const globalSource = store.state.sourceParam

  if (globalSource && !to.query.source) {
    // 如果全局有 source 参数，但当前路由没有，则添加
    next({
      ...to,
      query: {
        ...to.query,
        source: globalSource
      }
    })
    return
  }

  next()
})

export default router
